<template>
  <footer class="layout-footer">
    <div class="site-footer-inner">
      <div class="site-footer-legal">
        <span>© {{ year }} 台州金电保数字科技有限公司</span>
        <div class="site-footer-records">
          <a v-if="setting.icp" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{{ setting.icp }}</a>
          <a v-if="setting.gov_record" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33109902000112" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/images/gongan.png" alt="公安备案" />{{ setting.gov_record }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { config } from '@/api/config';
export default {
  name: 'Footer',
  data() {
    return { setting: {}, year: new Date().getFullYear() };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    async getConfig() {
      try {
        this.setting = (await config()) || {};
      } catch (_) {
        this.setting = {};
      }
    },
  },
};
</script>

<style lang="less" scoped>
.layout-footer { background: #f5f5f7; color: #6e6e73; font-weight: 400; }
.site-footer-inner { width: ~"calc(100% - 80px)"; max-width: 1120px; margin: 0 auto; padding: 24px 0; }
.site-footer-legal { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px 24px; font-size: 12px; line-height: 1.8; }
.site-footer-records { display: flex; flex-wrap: wrap; gap: 8px 24px; }
.site-footer-legal a { display: inline-flex; align-items: center; gap: 6px; color: #6e6e73; &:hover { color: #0066cc; } }
.site-footer-legal img { width: 16px; height: 16px; }
.layout-footer a:focus-visible { outline: 2px solid #0071e3 !important; outline-offset: 4px; }
@media (max-width: 600px) {
  .site-footer-inner { width: ~"calc(100% - 40px)"; }
  .site-footer-legal { flex-direction: column; align-items: flex-start; }
}
</style>
